<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>修改密码</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="personal_edit_passWord_box">
      <el-form ref="editPassword" :model="user" :rules="rules" @submit.prevent="submitForm">
        <el-form-item>
          绑定手机号: {{user.tel}}
        </el-form-item>
        <el-form-item prop="code" >
          <el-input type="text" v-model="user.code" placeholder="请输入验证码">
            <el-button slot="append" @click="obtain"  v-show="isCodeShow">发送验证码</el-button>
            <el-button class="disabled_btn" slot="append" :disabled="!isCodeShow" v-show="!isCodeShow">{{secondsCount}}秒后重发</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="user.password" placeholder="请新输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="repeat_password">
          <el-input type="password" v-model="user.repeat_password" placeholder="请确认密码"></el-input>
        </el-form-item>
        <div class="rg_form_box_form_item">
          <el-button type="primary" class="rg_form_box_form_sub" @click="submitForm('editPassword')">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 倒计秒数初始化定义
      secondsCount: 0,
      // 是否显示发送验证码按钮
      isCodeShow: true,
      user: {
        tel: '',
        code: '',
        password: '',
        repeat_password: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '长度最少8位', trigger: 'blur' }
        ],
        repeat_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === this.user.password) {
                callback()
              } else {
                callback(new Error('两次输入密码不一致'))
              }
            }
          }
        ]
      }
    }
  },
  created () {
    this.getTel()
  },
  methods: {
    // 获取手机号
    getTel () {
      const vueThat = this
      vueThat.myApi.getTel().then((res) => {
        if (res.data.code === 200) {
          const str = res.data.data.substring(3, 7)
          vueThat.user.tel = res.data.data.replace(str, '****')
        }
      })
    },
    // 获取验证码
    async obtain () {
      const vueThat = this
      await vueThat.$store.dispatch('user/send', { number: vueThat.user.tel, type: 'personal' }).then((res) => {
        if (res.data.code === 200) {
          vueThat.secondsCount = 60
          // 切换倒计时按钮
          vueThat.isCodeShow = false
          // 倒计时函数
          const timer = setInterval(function () {
            vueThat.secondsCount--
            if (vueThat.secondsCount <= 0) {
              clearInterval(timer)
              vueThat.isCodeShow = true
            }
          }, 1000)
        }
      })
    },
    // 提交
    async submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        if (valid) {
          vueThat.myApi.editPassword(vueThat.user).then((res) => {
            if (res.data.code === 200) {
              vueThat.$message.success('修改密码成功')
              vueThat.user = {
                tel: '',
                code: '',
                password: '',
                repeat_password: ''
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .personal_edit_passWord_box{
    width: 400px;
    margin: 0 auto;
  }
</style>
